import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { NAVIGATE_MESSAGE, inAppPath } from '../lib/notificationNavigation'

/**
 * A tap on a browser push while the site is open: the service worker (public/push-sw.js) asks this
 * tab to go to the push's address, and the router takes it without a reload. The answer on the
 * port tells the worker not to navigate the tab itself.
 */
export default function NotificationClickNavigator() {
  const navigate = useNavigate()

  useEffect(() => {
    const container = typeof navigator !== 'undefined' ? navigator.serviceWorker : undefined
    if (!container) return undefined
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: unknown; url?: unknown } | null
      if (!data || data.type !== NAVIGATE_MESSAGE) return
      const path = inAppPath(data.url, window.location.origin)
      if (!path) return
      event.ports[0]?.postMessage('ok')
      navigate(path)
    }
    container.addEventListener('message', onMessage)
    return () => container.removeEventListener('message', onMessage)
  }, [navigate])

  return null
}
